import type { LibItemSysIcon } from '@types';
import { cbIconList } from '../LibCBIconModal/cbIconList';
import { iconList } from '../LibIconModal/sysIconList';

export interface LibItemCLayerIcon extends LibItemSysIcon {
  isGif?: boolean;
}

type Group = {
  name: string;
  list: LibItemCLayerIcon[];
};

const layerIconList: Group = {
  name: '图层图标',
  list: [
    { url: '/imgs/1@2x.dbbefbe5240a0e8462322417d621e2c7.png', frame: 1 },
    { url: '/imgs/2@2x.d42ea176d747a7f1e4133583f52f042e.png', frame: 1 },
    { url: '/imgs/3@2x.7cc427ac47579a16121e33871d001702.png', frame: 1 },
    { url: '/imgs/4@2x.1c4650de9e59970e5506cdb3f6ed8a98.png', frame: 1 },
    { url: '/imgs/5@2x.6032372d29cd8dd29a6b7ddff7803578.png', frame: 1 },
    { url: '/imgs/6@2x.3984ebcf5d1aa4cd163f28f0d3402015.png', frame: 1 },
    { url: '/imgs/7@2x.f6c25f5507c238169be6c85aeb063309.png', frame: 1 },
    { url: '/imgs/8@2x.1db2fe3f11963688c2602b6599368c88.png', frame: 1 },
    { url: '/imgs/9@2x.2d500ae92e1cd538d50b1d2147a6fdc3.png', frame: 1 },
    { url: '/imgs/10@2x.914154479461c3423cbe0ec52f1c185f.png', frame: 1 },
    { url: '/hotspots/system/layer/shang.png', frame: 1 },
    {
      url: '/hotspots/system/layer/hudie2.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/CD.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/yezi.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/feiji.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/yuncai1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/hudie1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/yinyue1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/aixin.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/feihe1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/biankuang1.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/yinghua.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/fudai.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/liuye.gif',
      frame: 1,
      isGif: true,
    },
    {
      url: '/hotspots/system/layer/biankuang2.gif',
      frame: 1,
      isGif: true,
    },
  ],
};

const buttonList: Group = {
  name: '按钮图标',
  list: cbIconList.reduce(
    (acc: LibItemSysIcon[], group: Group) => acc.concat(group.list),
    []
  ),
};

const hotspotList: Group = {
  name: '热点图标',
  list: iconList.reduce(
    (acc: LibItemSysIcon[], group: Group) =>
      acc.concat(group.list.filter((x) => x.frame === 1)),
    []
  ),
};

export const cLayerIconAll: Group = {
  name: '全部',
  list: [...layerIconList.list, ...buttonList.list, ...hotspotList.list],
};

export const cLayerIconList: Group[] = [
  cLayerIconAll,
  layerIconList,
  buttonList,
  hotspotList,
];
